import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import StoreApplicationState from "@store/Store/StoreApplicationState";
import getBooleanProperty from "@store/utilities/getBooleanProperty";

export const getIsCreditHold = (state: ApplicationState | StoreApplicationState) => {
	return getBooleanProperty(getCurrentCartState(state).value?.properties.creditHold || "");
}

export const getShipViaAllowScheduledShipDate = (state: ApplicationState | StoreApplicationState) => {
	return getBooleanProperty(getCurrentCartState(state).value?.properties.shipViaAllowScheduledShipDate || "");
}

export const getTaxNotAvailable = (state: ApplicationState | StoreApplicationState) => {
	return getBooleanProperty(getCurrentCartState(state).value?.properties.taxNotAvailable || "");
}
